import React from "react";
import { IconScale } from "@tabler/icons-react";
import { SpotlightActionData } from "@mantine/spotlight";
import { navigate } from "vike/client/router";

// ⚠️⚠️⚠️ Disclaimer: These Terms of Service are provided for informational purposes only and serve as a template.
// You are solely responsible for legal compliance.

async function onSubmit(route: string) {
  const navigationPromise = navigate(route);
  await navigationPromise;
}

export const termsOfService: readonly SpotlightActionData[] = [
  {
    id: "tos-intro",
    label: "Introduction",
    description:
      "By using a11yStart (https://a11ystart.blue/), you confirm your acceptance of, and agree to be bound by, these Terms of Service.",
    onClick: () => onSubmit("/terms-of-service"),
    leftSection: <IconScale aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "tos-agreement",
    label: "Agreement Activation",
    description:
      "This Agreement takes effect on the date on which you first access the a11yStart application or services.",
    onClick: () => onSubmit("/terms-of-service"),
    leftSection: <IconScale aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "tos-license",
    label: "Software License & Termination",
    description:
      "The a11yStart license grants perpetual, unrestricted access to the software upon a one-time purchase. There are no recurring fees or subscriptions. However, the licensor retains full rights to terminate this license at any time, for any reason, without notice. This provision allows the licensor to maintain control over the distribution and usage of the software.",
    onClick: () => onSubmit("/terms-of-service"),
    leftSection: <IconScale aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "tos-refund",
    label: "Refund Policy",
    description:
      "All purchases are final. Due to the nature of digital products, no refunds or exchanges will be provided once access has been granted.",
    onClick: () => onSubmit("/terms-of-service"),
    leftSection: <IconScale aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "tos-disclaimer",
    label: "Disclaimer of Guarantee",
    description:
      "a11yStart is provided 'as is' with no warranties or guarantees, express or implied. We do not guarantee that the software will meet your needs or operate uninterrupted or error-free.",
    onClick: () => onSubmit("/terms-of-service"),
    leftSection: <IconScale aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "tos-liability",
    label: "Limitation of Liability",
    description:
      "We are not liable for any indirect, incidental, special, or consequential damages, including but not limited to data loss, business interruption, or loss of profits. Our total liability shall not exceed the amount you paid for the software.",
    onClick: () => onSubmit("/terms-of-service"),
    leftSection: <IconScale aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "tos-user-content",
    label: "User-Generated Content",
    description:
      "You are solely responsible for any content you create, upload, or distribute using the a11yStart platform. a11yStart assumes no responsibility for user-submitted materials.",
    onClick: () => onSubmit("/terms-of-service"),
    leftSection: <IconScale aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "tos-pricing",
    label: "Price Policy",
    description:
      "We reserve the right to change pricing at any time. Early adopters who purchase at current rates will retain access at that price, even if rates increase in the future.",
    onClick: () => onSubmit("/terms-of-service"),
    leftSection: <IconScale aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "tos-governing-law",
    label: "Governing Law & Jurisdiction",
    description:
      "These terms are governed by the laws of France. All disputes shall fall under the exclusive jurisdiction of the French courts. Users acknowledge that no partnership, joint venture, or employment relationship is created through use of the services.",
    onClick: () => onSubmit("/terms-of-service"),
    leftSection: <IconScale aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
  {
    id: "tos-modifications",
    label: "Terms Modifications",
    description:
      "We reserve the right to change these terms at any time without notice. Continued use of the platform implies acceptance of the modified terms.",
    onClick: () => onSubmit("/terms-of-service"),
    leftSection: <IconScale aria-label="Navigate to the selected page" size={24} stroke={1.5} />,
  },
];
